<template>
  <div>
    <el-dialog title="选择设备" :visible="addClientVisible" :close-on-click-modal="false" @close="clear" size="large" top="1%">
      <div class="search-area text-right">
        <div class="box-inline" style="width: 200px;">
          <el-select v-model="queryFormBind.tags" clearable placeholder="输入设备标签搜索" filterable style="width: 100%;">
            <el-option v-for="item in tags" :value="item" :label="item" :key="item"></el-option>
          </el-select>
        </div>
        <div class="box-inline" style="width: 200px;">
          <el-input v-model="queryFormBind.q" placeholder="输入设备编号或名称"></el-input>
        </div>
        <div class="box-inline" style="width: 200px;">
          <el-select v-model="queryFormBind.group_id" style="width: 100%;" placeholder="选择设备分组">
            <el-option label="所有分组" :value="null"></el-option>
            <el-option v-for="group in groups" :value="group.id" :label="group.name" :key="group.id"></el-option>
          </el-select>
        </div>
        <el-button size="small" @click="onSubmitQuery" title="搜索" class="mar-btm">
          <i class="ion-search"></i>
        </el-button>
      </div>
      <div class="pos-rel">
        <el-table :data="clientList" v-loading="loading" stripe>
          <el-table-column width="30">
            <template scope="scope">
              <el-checkbox :label="scope.row.id" v-model="initSelection" class="noLabel"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="SN" label="设备编号" width="200"></el-table-column>
          <el-table-column prop="Name" label="设备名称" min-width="100"></el-table-column>
          <el-table-column prop="DciGroupID" label="所属分组" min-width="100">
            <template scope="scope">
              <span>{{findGroup(scope.row.DciGroupID)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="tags" label="设备标签" min-width="100">
            <template scope="scope">
              <span v-for="tag in scope.row.tags">
                <el-tag type="primary">{{tag}}</el-tag>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-checkbox @change="isCheckALL" v-model="checkAll" style="position: absolute;top: 12px;left: 19px"></el-checkbox>
      </div>
      <div class="clearfix mar-top">
        <el-pagination class="pull-right"
          @current-change="changePage"
          layout="total, prev, pager, next"
          :total="total"
          :current-page="currentPage"
          :page-size="15">
        </el-pagination>
        <div class="pull-left mar-lft">
          <span class="text-muted">{{`已选择 ${initSelection.length} 个设备`}}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="check">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style>
  .noLabel .el-checkbox__label{
    display: none;
  }
</style>
<script>
import { mapState } from 'vuex';
import { find as _find, cloneDeep as _cloneDeep, remove as _remove } from 'lodash';

export default {
  data() {
    return {
      applicationId: this.$route.params.appId,
      clientList: [],
      // 是否全选
      checkAll: false,
      // 确定前的选项
      initSelection: [],
      // 确定后的选项
      selection: [],
      // 确定前设备所有信息
      initClientSelected: [],
      // 确定后设备所有信息
      clientSelected: [],
      // 分页后的loading
      loading: false,
      addClientVisible: false,
      // 查询设备列表的参数
      queryForm: {
        q: '',
        tags: '',
        group_id: null,
      },
      queryFormBind: {
        q: '',
        tags: '',
        group_id: null,
      },
      tags: [],
      total: 0,
      currentPage: 1,
      groups: [],
    };
  },
  // computed: {
  //   ...mapState({
  //     groups: state => state.application.groups,
  //   }),
  // },
  watch: {
    initSelection() {
      // 每次勾选单个后，是否勾上全选
      if (this.clientList.length &&
        this.clientList.every(citem => this.initSelection.some(sitem => citem.id === sitem))) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
      // 每次勾选单个后，存储该client信息，如果是取消勾选此项，存在信息，则删除
      this.clientList.forEach((item) => {
        if (this.initSelection.indexOf(item.id) >= 0) {
          if (!_find(this.initClientSelected, { id: item.id })) {
            this.initClientSelected.push(item);
          }
        } else if (_find(this.initClientSelected, { id: item.id })) {
          _remove(this.initClientSelected, client => client.id === item.id);
        }
      });
    },
    clientList() {
      // 翻页后确定是否要勾上全选
      if (this.clientList.length &&
        this.clientList.every(citem => this.initSelection.some(sitem => citem.id === sitem))) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
  },
  mounted() {
    // 当从设备管理进入到该页面，获取相关信息
    if (this.$route.query.id) {
      this.queryForm.q = this.$route.query.sn;
      this.selection.push(+this.$route.query.id);
    }
    this.getClientList(+this.$route.query.id);
    this.remoteTag();
  },
  methods: {
    // 通过ref外部调用，显示dialog
    showAddClient() {
      this.initSelection = [...this.selection];
      this.addClientVisible = true;
    },
    // 清空dialog数据
    clear() {
      this.selection = [];
      this.clientSelected = [];
      this.queryForm = {
        q: '',
        tags: '',
        group_id: '',
      };
      this.queryFormBind = {
        q: '',
        tags: '',
        group_id: '',
      };
      // this.$emit('changeSelection', this.clientSelected);
      this.getClientList();
    },
    // 取消时还原数据
    cancel() {
      if (this.addClientVisible === true) {
        this.initSelection = [...this.selection];
        this.initClientSelected = _cloneDeep(this.clientSelected);
        this.addClientVisible = false;
        // this.$emit('changeSelection', this.clientSelected);
      }
    },
    // 确认选择
    check() {
      this.selection = [...this.initSelection];
      this.clientSelected = _cloneDeep(this.initClientSelected);
      this.addClientVisible = false;
      this.$emit('changeSelection', this.clientSelected);
    },
    // 切换全选时
    isCheckALL() {
      let array = this.clientList.map(item => item.id);
      if (this.checkAll) {
        // 过滤已选项
        array = array.filter(item => this.initSelection.indexOf(item) < 0);
        this.initSelection.push(...array);
      } else {
        array.forEach((item) => {
          const index = this.initSelection.indexOf(item);
          if (index >= 0) {
            this.initSelection.splice(index, 1);
          }
        });
      }
    },
    // 翻页
    changePage(page) {
      this.currentPage = page;
      this.getClientList();
    },
    // 渲染设备列表时获取分组名
    findGroup(id) {
      return _find(this.groups, { id }).name;
    },
    // 获取设备列表
    getClientList(id) {
      this.loading = true;
      this.$axios.get(`dci/station`,
        { params: { ...this.queryForm, page: this.currentPage } })
      .then((response) => {
        this.total = response.data.total;
        this.loading = false;
        this.clientList = response.data.data;
        if (id) {
          this.clientSelected.push(_find(this.clientList, { id }));
        }
      }, (response) => {
        this.loading = false;
        this.$iot.resp(response);
      });
    },
    // 提交搜索
    onSubmitQuery() {
      this.queryForm = { ...this.queryFormBind };
      // changePage会监测页码的变化，自动调用getClientList
      if (this.currentPage !== 1) {
        this.currentPage = 1;
      } else {
        this.getClientList();
      }
    },
    // 远程搜索设备标签
    remoteTag() {
      this.$axios.get(`dci/station/tag`).then((response) => {
        this.tags = response.data;
      }, (response) => {
        this.$iot.resp(response);
      });
    },
  },
};
</script>
